// "Re-Order?" on an imprint (Stephanie 2026-10-26): kept in the decoration's
// repeat_logo text — "No", "Yes", or "Yes — PO #33252" — so it reaches the
// PO and the supplier's PO page as before. Pure; the web and the API share it.

/** Pure: what goes in repeat_logo. Yes with a PO → "Yes — PO #33252". */
export function reorderValue(answer: "" | "Yes" | "No", poNumber: string | null | undefined): string | null {
  if (answer === "") return null;
  if (answer === "No") return "No";
  const po = (poNumber ?? "").trim().replace(/^#/, "").replace(/^po\s*#?\s*/i, "");
  return po ? `Yes — PO #${po}` : "Yes";
}

/** Pure: read it back ("Yes — PO #33252" → Yes + "33252"; older typed text kept as the PO note). */
export function readReorder(v: string | null | undefined): { answer: "" | "Yes" | "No"; po: string } {
  const t = (v ?? "").trim();
  if (t === "") return { answer: "", po: "" };
  if (/^no\b/i.test(t)) return { answer: "No", po: "" };
  const m = t.match(/PO\s*[#:-]?\s*([A-Za-z0-9][A-Za-z0-9-]*)/i);
  if (/^yes\b/i.test(t)) return { answer: "Yes", po: m?.[1] ?? "" };
  // Older free text ("Same as PO-1234", "Re-order: PO 33252") reads as a re-order.
  return m ? { answer: "Yes", po: m[1]! } : { answer: "Yes", po: t };
}

